// SEO & GEO Assessment — Landing Page JS
// 3-step in-card flow: URL input → Loader → Email gate/sent state

import { getStoredUtmParams } from "./lib/utm_tracking"

function bindSeoAssessment(toolCard) {
  if (!toolCard) return;

  const urlForm = toolCard.querySelector("#seo-url-form");
  if (!urlForm || urlForm.dataset.seoBound) return;
  urlForm.dataset.seoBound = "true";

  const emailUpfront = toolCard?.dataset.emailUpfront === "true";
  const successRedirect = toolCard?.dataset.successRedirect;
  const urlInput    = toolCard.querySelector("#seo-url");
  const urlSubmit   = toolCard.querySelector("#seo-url-submit");
  const urlError    = toolCard.querySelector("#seo-url-error");
  const stepUrl     = toolCard.querySelector("#seo-step-url");
  const stepLoader  = toolCard.querySelector("#seo-step-loader");
  const stepEmail   = toolCard.querySelector("#seo-step-email");
  const loaderPhrase = toolCard.querySelector("#seo-loader-phrase");
  const upfrontEmailInput = toolCard.querySelector("#seo-user-email");
  const emailForm        = toolCard.querySelector("#seo-email-form");
  const emailInput       = toolCard.querySelector("#seo-email");
  const emailSubmit      = toolCard.querySelector("#seo-email-submit");
  const emailError       = toolCard.querySelector("#seo-email-error");
  const consentMarketing = toolCard.querySelector("#seo-consent-marketing");
  const consentPrivacy   = toolCard.querySelector("#seo-consent-privacy");
  const errorMarketing   = toolCard.querySelector("#seo-error-marketing");
  const errorPrivacy     = toolCard.querySelector("#seo-error-privacy");

  const PHRASES = [
    "Lettura dei tag HTML...",
    "Estrazione delle Entità Semantiche...",
    "Verifica della gerarchia degli Heading...",
    "Analisi dei segnali E-E-A-T...",
    "Calcolo finale degli Score SEO e GEO..."
  ];

  let phraseInterval = null;
  let capturedToken  = null;

  function startPhrases() {
    let idx = 0;
    if (loaderPhrase) loaderPhrase.textContent = PHRASES[0];
    phraseInterval = setInterval(() => {
      idx = (idx + 1) % PHRASES.length;
      if (loaderPhrase) loaderPhrase.textContent = PHRASES[idx];
    }, 2800);
  }

  function stopPhrases() {
    clearInterval(phraseInterval);
    phraseInterval = null;
  }

  function showState(activeEl) {
    [stepUrl, stepLoader, stepEmail].forEach(el => {
      if (el) el.hidden = (el !== activeEl);
    });
  }

  function isValidUrl(str) {
    try {
      const u = new URL(str);
      return (u.protocol === "http:" || u.protocol === "https:") && u.hostname.includes(".");
    } catch {
      return false;
    }
  }

  function isValidEmail(str) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(str);
  }

  if (urlInput) {
    urlInput.addEventListener("input", () => {
      const val = urlInput.value.trim();
      if (!val) {
        urlInput.classList.remove("ux-input--error", "ux-input--ok");
        if (urlError) { urlError.hidden = true; urlError.textContent = ""; }
      } else if (isValidUrl(val)) {
        urlInput.classList.add("ux-input--ok");
        urlInput.classList.remove("ux-input--error");
        if (urlError) { urlError.hidden = true; urlError.textContent = ""; }
      } else {
        urlInput.classList.add("ux-input--error");
        urlInput.classList.remove("ux-input--ok");
      }
    });
  }

  if (upfrontEmailInput) {
    upfrontEmailInput.addEventListener("input", () => {
      const val = upfrontEmailInput.value.trim();
      if (!val) {
        upfrontEmailInput.classList.remove("ux-input--error", "ux-input--ok");
        if (urlError) { urlError.hidden = true; urlError.textContent = ""; }
      } else if (isValidEmail(val)) {
        upfrontEmailInput.classList.add("ux-input--ok");
        upfrontEmailInput.classList.remove("ux-input--error");
        if (urlError) { urlError.hidden = true; urlError.textContent = ""; }
      } else {
        upfrontEmailInput.classList.add("ux-input--error");
        upfrontEmailInput.classList.remove("ux-input--ok");
      }
    });
  }

  // ── Step 1: URL form submit ─────────────────────────────────────────────────

  urlForm.addEventListener("submit", async (e) => {
    e.preventDefault();

    const url = urlInput?.value?.trim();
    const upfrontEmail = upfrontEmailInput?.value?.trim() || "";
    if (!isValidUrl(url)) {
      if (urlInput) { urlInput.classList.add("ux-input--error"); urlInput.classList.remove("ux-input--ok"); }
      if (urlError) { urlError.hidden = false; urlError.textContent = "Inserisci un URL valido che inizi con https://"; }
      urlInput?.focus();
      return;
    }

    if (emailUpfront && !isValidEmail(upfrontEmail)) {
      if (upfrontEmailInput) {
        upfrontEmailInput.classList.add("ux-input--error");
        upfrontEmailInput.classList.remove("ux-input--ok");
      }
      if (urlError) {
        urlError.hidden = false;
        urlError.textContent = "Inserisci un indirizzo email aziendale valido.";
      }
      upfrontEmailInput?.focus();
      return;
    }

    let consentValid = true;
    if (consentMarketing && !consentMarketing.checked) {
      if (errorMarketing) { errorMarketing.textContent = "Questo consenso è obbligatorio."; errorMarketing.hidden = false; }
      consentValid = false;
    } else if (errorMarketing) { errorMarketing.hidden = true; }
    if (consentPrivacy && !consentPrivacy.checked) {
      if (errorPrivacy) { errorPrivacy.textContent = "Questo consenso è obbligatorio."; errorPrivacy.hidden = false; }
      consentValid = false;
    } else if (errorPrivacy) { errorPrivacy.hidden = true; }
    if (!consentValid) return;

    if (urlInput) { urlInput.classList.remove("ux-input--error"); urlInput.classList.add("ux-input--ok"); }
    if (upfrontEmailInput && emailUpfront) {
      upfrontEmailInput.classList.remove("ux-input--error");
      upfrontEmailInput.classList.add("ux-input--ok");
    }
    if (urlError) { urlError.hidden = true; urlError.textContent = ""; }
    if (urlSubmit) urlSubmit.disabled = true;

    showState(stepLoader);
    startPhrases();

    try {
      const response = await fetch("/seo_assessments/stream", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content || ""
        },
        body: JSON.stringify({
          lead: {
            url,
            email: emailUpfront ? upfrontEmail : undefined,
            send_report_email: emailUpfront,
            consent_marketing: consentMarketing?.checked ? "1" : "0",
            consent_privacy: consentPrivacy?.checked ? "1" : "0",
            ...getStoredUtmParams()
          }
        })
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        const details = (data.errors || []).concat([data.error || ""]).filter(Boolean).join(" ");
        throw new Error(details || "Errore durante l'analisi. Riprova tra poco.");
      }

      capturedToken = data.token;

      // Poll until the background job completes
      const POLL_INTERVAL_MS = 3000;
      const MAX_POLL_ATTEMPTS = 80; // ~4 minutes
      const csrf = document.querySelector("meta[name='csrf-token']")?.content || "";

      for (let attempt = 0; attempt < MAX_POLL_ATTEMPTS; attempt++) {
        await new Promise(r => setTimeout(r, POLL_INTERVAL_MS));
        const pollRes = await fetch(`/seo_assessments/${capturedToken}.json`, {
          headers: { "X-CSRF-Token": csrf }
        });
        if (!pollRes.ok) throw new Error("Errore nel controllo dell'analisi.");
        const result = await pollRes.json().catch(() => ({}));
        if (result.status === "completed") break;
        if (result.status === "failed") throw new Error(result.error || "Errore durante l'analisi.");
        if (attempt === MAX_POLL_ATTEMPTS - 1) throw new Error("Timeout: l'analisi ha impiegato troppo tempo. Riprova.");
      }

      stopPhrases();

      if (emailUpfront && successRedirect) {
        window.location.href = successRedirect;
        return;
      }

      showState(stepEmail);
      if (!emailUpfront && emailInput) emailInput.focus();

    } catch (err) {
      stopPhrases();
      const msg = err.message || "Errore imprevisto. Riprova tra poco.";
      showState(stepUrl);
      if (urlError) { urlError.textContent = msg; urlError.hidden = false; }
      if (urlSubmit) urlSubmit.disabled = false;
    }
  });

  // ── Step 3: Email form submit ───────────────────────────────────────────────

  if (emailForm) {
    emailForm.addEventListener("submit", async (e) => {
      e.preventDefault();

      const email = emailInput?.value?.trim();
      if (!email) return;

      if (emailError) { emailError.hidden = true; emailError.textContent = ""; }
      if (emailSubmit) emailSubmit.disabled = true;

      if (!capturedToken) {
        if (emailError) { emailError.textContent = "Sessione scaduta. Ricarica la pagina e riprova."; emailError.hidden = false; }
        if (emailSubmit) emailSubmit.disabled = false;
        return;
      }

      try {
        const response = await fetch(`/seo_assessments/${capturedToken}/claim`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content || ""
          },
          body: JSON.stringify({ lead: { email } })
        });

        const data = await response.json().catch(() => ({}));

        if (!response.ok) {
          throw new Error(data.error || "Errore. Riprova tra poco.");
        }

        window.location.href = data.redirect_url;

      } catch (err) {
        if (emailError) { emailError.textContent = err.message || "Errore. Riprova tra poco."; emailError.hidden = false; }
        if (emailSubmit) emailSubmit.disabled = false;
      }
    });
  }
}

function initSeoAssessment() {
  document.querySelectorAll("#seo-tool-card").forEach(bindSeoAssessment);
}

document.addEventListener("turbo:load", initSeoAssessment);
